import cx from 'classnames';
import React from 'react';

import { AppType } from 'src/services/cms/typesUtil';
import styles from './BusinessResourceGrid.scss';

type BusinessResourceGridProps = AppType.Component<{
  headline: string;
}>;

export const BusinessResourceGrid: React.FC<BusinessResourceGridProps> = ({
  headline,
  ...props
}) => {
  return (
    <section className={cx(styles.businessResourceGrid)} {...props._attributes}>
      BusinessResourceGrid works
      <h2>{headline}</h2>
    </section>
  );
};
